// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const PhoenixlingSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'phoenixling-idle',
    metadata: {
      frames: {
        'phoenixling-idle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-idle-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-idle-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-idle-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/phoenixling/idle.png',
        size: {
          w: 256,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'phoenixling-idle': [
          'phoenixling-idle-0',
          'phoenixling-idle-1',
          'phoenixling-idle-2',
          'phoenixling-idle-3',
        ],
      },
    },
  },
  {
    name: 'phoenixling-run',
    metadata: {
      frames: {
        'phoenixling-run-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-run-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-run-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-run-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/phoenixling/run.png',
        size: {
          w: 256,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'phoenixling-run': [
          'phoenixling-run-0',
          'phoenixling-run-1',
          'phoenixling-run-2',
          'phoenixling-run-3',
        ],
      },
    },
  },
  {
    name: 'phoenixling-attack',
    metadata: {
      frames: {
        'phoenixling-attack-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-attack-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-attack-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-attack-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-attack-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-attack-5': {
          frame: {
            x: 320,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-attack-6': {
          frame: {
            x: 384,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-attack-7': {
          frame: {
            x: 448,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/phoenixling/attack.png',
        size: {
          w: 512,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'phoenixling-attack': [
          'phoenixling-attack-0',
          'phoenixling-attack-1',
          'phoenixling-attack-2',
          'phoenixling-attack-3',
          'phoenixling-attack-4',
          'phoenixling-attack-5',
          'phoenixling-attack-6',
          'phoenixling-attack-7',
        ],
      },
    },
  },
  {
    name: 'phoenixling-exhaust',
    metadata: {
      frames: {
        'phoenixling-exhaust-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-exhaust-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-exhaust-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-exhaust-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/phoenixling/exhaust.png',
        size: {
          w: 256,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'phoenixling-exhaust': [
          'phoenixling-exhaust-0',
          'phoenixling-exhaust-1',
          'phoenixling-exhaust-2',
          'phoenixling-exhaust-3',
        ],
      },
    },
  },
  {
    name: 'phoenixling-die',
    metadata: {
      frames: {
        'phoenixling-die-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-die-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-die-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-die-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-die-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-die-5': {
          frame: {
            x: 320,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-die-6': {
          frame: {
            x: 384,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-die-7': {
          frame: {
            x: 448,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/phoenixling/die.png',
        size: {
          w: 512,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'phoenixling-die': [
          'phoenixling-die-0',
          'phoenixling-die-1',
          'phoenixling-die-2',
          'phoenixling-die-3',
          'phoenixling-die-4',
          'phoenixling-die-5',
          'phoenixling-die-6',
          'phoenixling-die-7',
        ],
      },
    },
  },
  {
    name: 'phoenixling-rebirth',
    metadata: {
      frames: {
        'phoenixling-rebirth-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-rebirth-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-rebirth-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-rebirth-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-rebirth-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-rebirth-5': {
          frame: {
            x: 320,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-rebirth-6': {
          frame: {
            x: 384,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-rebirth-7': {
          frame: {
            x: 448,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'phoenixling-rebirth-8': {
          frame: {
            x: 512,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/phoenixling/rebirth.png',
        size: {
          w: 576,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'phoenixling-rebirth': [
          'phoenixling-rebirth-0',
          'phoenixling-rebirth-1',
          'phoenixling-rebirth-2',
          'phoenixling-rebirth-3',
          'phoenixling-rebirth-4',
          'phoenixling-rebirth-5',
          'phoenixling-rebirth-6',
          'phoenixling-rebirth-7',
          'phoenixling-rebirth-8',
        ],
      },
    },
  },
];
